/* istanbul ignore file */

export { SectionHeader as default } from "./SectionHeader";
